import { getLookaheadTrades } from "./lookahead.selector";
import { getTradeId } from "./phaseplan.selector";
import { getCurrentUserId, isAdmin } from "./user.selector";
import { createDeepEqualSelector } from "./util.selector";

export const getUserTrades = createDeepEqualSelector([getLookaheadTrades, getCurrentUserId], (trades, currentUserId) => {
    

    const yourTrades = Object.keys(trades).filter(tradeId => {
        const users = !!trades[tradeId].users ? trades[tradeId].users : {}
        
        return users[currentUserId]
    } )

    return new Set<string>(yourTrades)
})


// WEBPACK FOOTER //
// ./src/selectors/trade.selector.ts